<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        خلاصه صورت وضعیت حمل بار
                    </v-card-title>

                    <v-card-text v-if="report_type==1">
                        <div class="container">
                            <v-row>
                                <v-col cols="12" class="text-right">
                                    <h3> گزارشات</h3>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-select
                                            dense
                                            id="truck_type"
                                            v-model="report_type"
                                            :items="[{label:'نمایش کل صورت وضعیت حمل بار',value:1},{label:'نمایش روزانه کل صورت وضعیت حمل بار',value:4},{label:'ریز کارکرد محل تخلیه',value:2},{label:'نمایش کل صورت وضعیت حمل بار با احتساب سود',value:3}]"
                                            item-value="value"
                                            item-text="label"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_select('end_date_id_date_day')"
                                                    first_id="start_date_id_"
                                                    v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    first_id="end_date_id_"
                                                    @last_focus="another_focus_inside('discharge_place1')"


                                                    v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>

                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    v-model="selected_discharge_place"
                                                    :cacheOptions="false"
                                                    id="discharge_place1"
                                                    :multiple="true"
                                                    :defaultExpandLevel="1"

                                                    :options="discharge_places_all"
                                                    placeholder="جستجو محل تخلیه"
                                                    :normalizer="normalizer_discharge_place"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_all" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-col cols="12" :id="body_id">
                                <!--                                <v-row style="margin-right: 20px">-->
                                <!--                                    <div class="chip" v-for="item in selected_discharge_place" :key="item">-->
                                <!--                                        {{discharge_places.filter(x=>x.id==item)[0].name}}-->
                                <!--                                    </div>-->

                                <!--                                </v-row>-->

                                <VDataTable2
                                        dense
                                        hide-default-footer
                                        height="400"
                                        fixed-header
                                        disable-pagination
                                        v-if="items_delivery_all.length>0"
                                        multi-sort
                                        class="margin-auto  table-bordered"
                                        :headers="headers_deliver_all"
                                        :items-per-page="1000"
                                        :items="items_delivery_all"
                                >
                                    <template v-slot:item.row_id="{item }">
                                        {{ item._row_index+1}}
                                    </template>

                                    <template v-slot:item.driver_price="{ item }">
                                        {{ get_currency(item.driver_price) }}
                                    </template>
                                    <template v-slot:item.total_real_driver_price="{ item }">
                                        {{ get_currency(item.total_real_driver_price) }}
                                    </template>
                                    <template v-slot:item.total_real_employer_price="{ item }">
                                        {{ get_currency(item.total_real_employer_price) }}
                                    </template>
                                    <template v-slot:item.profit="{ item }">
                                        {{ get_currency( item.total_real_employer_price - item.total_real_driver_price)
                                        }}
                                    </template>
                                    <template slot="body.append">
                                        <tr class="pink--text">
                                            <th colspan="4" class="title">جمع کل</th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'count_truck')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_real_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_real_employer_price')) }}
                                            </th>

                                        </tr>
                                    </template>
                                </VDataTable2>
                            </v-col>
                            <v-btn small color="primary"
                                   @click="print_preview_with_header_title_height(body_id,header_id,footer_id,'Deliver Reports')">
                                پرینت
                            </v-btn>
                            <v-btn small color="success">
                                <download-excel
                                        class="btn btn-default"
                                        :data="table_excel_with_sum(items_delivery_all,[
                                            'count_truck',
'total_tonaje',
'total_real_tonaje',
'total_real_employer_price'
                                        ])"
                                        :fields="table_header_to_excel_heaader(headers_deliver_all)"
                                        worksheet="My Worksheet"
                                        name="filename.xls"
                                >
                                    خروجی اکسل
                                </download-excel>
                            </v-btn>
                        </div>
                    </v-card-text>
                    <v-card-text v-if="report_type==2">
                        <div class="container">
                            <v-row>
                                <v-col cols="12" class="text-right">
                                    <h3> گزارشات</h3>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-select
                                            dense
                                            id="truck_type"
                                            v-model="report_type"
                                            :items="[{label:'نمایش کل صورت وضعیت حمل بار',value:1},{label:'نمایش روزانه کل صورت وضعیت حمل بار',value:4},{label:'ریز کارکرد محل تخلیه',value:2},{label:'نمایش کل صورت وضعیت حمل بار با احتساب سود',value:3}]"
                                            item-value="value"
                                            item-text="label"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_select('end_date_id_date_day')"
                                                    first_id="start_date_id_"
                                                    v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    first_id="end_date_id_"
                                                    @last_focus="another_focus_inside('discharge_place_2')"


                                                    v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>

                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    v-model="selected_discharge_place"
                                                    :cacheOptions="false"
                                                    :multiple="true"
                                                    id="discharge_place_2"
                                                    :options="discharge_places"
                                                    placeholder="جستجو محل تخلیه"
                                                    :normalizer="normalizer_discharge_place"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_one" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <br>
                            <v-col cols="12" :id="body_id_one">
                                <!--                                <v-row style="margin-right: 20px">-->
                                <!--                                    <div v-if="one_discharge_place!=null" class="chip">-->
                                <!--                                        {{discharge_places.filter(x=>x.id==one_discharge_place)[0].name}}-->
                                <!--                                    </div>-->

                                <!--                                </v-row>-->
                                <VDataTable2
                                        dense
                                        hide-default-footer
                                        height="400"
                                        fixed-header
                                        disable-pagination
                                        :sort-by.sync="non_profit_sortBy"
                                        :sort-desc.sync="non_profit_sortDesc"
                                        v-if="items_delivery_one.length>0"
                                        class="margin-auto  table-bordered"
                                        :headers="headers_deliver_one"
                                        :items-per-page="1000"
                                        multi-sort
                                        :items="items_delivery_one"
                                >
                                    <template v-slot:item.row_id="{item }">
                                        {{ item._row_index+1}}
                                    </template>
                                    <template v-slot:item.truck_type="{ item }">
                                        <label v-if="item.truck_type==1">تک</label>
                                        <label v-if="item.truck_type==2">جفت</label>
                                    </template>

                                    <template v-slot:item.total_real_employer_price="{ item }">
                                        {{ get_currency(parseFloat(item.total_real_employer_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.employer_price="{ item }">
                                        {{ get_currency(parseFloat(item.employer_price).toFixed(0)) }}
                                    </template>
                                  <template v-slot:item.driver_price="{ item }">
                                        {{ get_currency(parseFloat(item.driver_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.real_driver_price="{ item }">
                                        {{ get_currency( parseFloat(item.real_driver_price).toFixed(0)) }}
                                    </template>
                                    <template slot="body.append">
                                        <tr class="pink--text">
                                            <th colspan="6" class="title">جمع کل</th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_one,
                                                'tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_one,
                                                'real_tonaje')) }}
                                            </th>
                                            <th class="title"></th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_one,
                                                'total_real_employer_price')) }}
                                            </th>
                                        </tr>
                                    </template>
                                </VDataTable2>
                            </v-col>
                            <v-col cols="12" v-show="false"  :id="body_id_one_non_profit">
                                <!--                                <v-row style="margin-right: 20px">-->
                                <!--                                    <div v-if="one_discharge_place!=null" class="chip">-->
                                <!--                                        {{discharge_places.filter(x=>x.id==one_discharge_place)[0].name}}-->
                                <!--                                    </div>-->

                                <!--                                </v-row>-->
                                <VDataTable2
                                        multi-sort
                                        dense
                                        :sort-by.sync="non_profit_sortBy"
                                        :sort-desc.sync="non_profit_sortDesc"
                                        height="400"
                                        fixed-header
                                        hide-default-footer
                                        disable-pagination
                                        v-if="items_delivery_one.length>0"
                                        class="margin-auto  table-bordered"
                                        :headers="headers_deliver_one_non_profit"
                                        :items-per-page="1000"
                                        :items="items_delivery_one"
                                >
                                    <template v-slot:item.row_id="{item }">
                                        {{ item._row_index+1}}
                                    </template>

                                    <template v-slot:item.truck_type="{ item }">
                                        <label v-if="item.truck_type==1">تک</label>
                                        <label v-if="item.truck_type==2">جفت</label>
                                    </template>

                                    <template v-slot:item.total_real_employer_price="{ item }">
                                        {{ get_currency(parseFloat(item.total_real_employer_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.driver_price="{ item }">
                                        {{ get_currency(parseFloat(item.driver_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.real_driver_price="{ item }">
                                        {{ get_currency( parseFloat(item.real_driver_price).toFixed(0)) }}
                                    </template>
                                    <template slot="body.append">
                                        <tr class="pink--text">
                                            <th colspan="5" class="title">جمع کل</th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_one,
                                                'tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_one,
                                                'real_tonaje')) }}
                                            </th>
<!--                                            <th class="title">{{ get_currency(calculate_items(items_delivery_one,-->
<!--                                                'driver_price')) }}-->
<!--                                            </th>-->
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_one,
                                                'total_real_employer_price')) }}
                                            </th>

                                        </tr>
                                    </template>
                                </VDataTable2>

                            </v-col>
                            <v-btn small color="primary"
                                   @click="print_preview_with_header_title_height(body_id_one_non_profit,header_id_one,footer_bedon_sorat_id,'Deliver Reports')">
                                پرینت بدون احتساب نرخ حمل
                            </v-btn>
                            <v-btn small color="warning"
                                   @click="print_preview_with_header_title_height(body_id_one,header_id_one,footer_sorat_id,'Deliver Reports')">
                                پرینت با درج نرخ حمل
                            </v-btn>

                            <v-btn small color="success">
                                <download-excel
                                        class="btn btn-default"
                                        :data="table_excel_with_sum(items_delivery_one,[
                                           'tonaje',
'real_tonaje',
'total_real_employer_price'])"
                                        :fields="table_header_to_excel_heaader(headers_deliver_one_non_profit)"
                                        worksheet="My Worksheet"
                                        name="filename.xls"
                                >
                                     خروجی اکسل بدون احتساب نرخ حمل
                                </download-excel>
                            </v-btn>
                            <v-btn small color="success">
                                <download-excel
                                        class="btn btn-default"
                                        :data="table_excel_with_sum(items_delivery_one,[
                                           'tonaje',
'real_tonaje',
'total_real_employer_price'])"
                                        :fields="table_header_to_excel_heaader(headers_deliver_one)"
                                        worksheet="My Worksheet"
                                        name="filename.xls"
                                >
                                     خروجی اکسل درج نرخ حمل
                                </download-excel>
                            </v-btn>
                        </div>
                    </v-card-text>
                    <v-card-text v-if="report_type==3">
                        <div class="container">
                            <v-row>
                                <v-col cols="12" class="text-right">
                                    <h3> گزارشات</h3>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-select
                                            dense
                                            id="truck_type"
                                            v-model="report_type"
                                            :items="[{label:'نمایش کل صورت وضعیت حمل بار',value:1},{label:'نمایش روزانه کل صورت وضعیت حمل بار',value:4},{label:'ریز کارکرد محل تخلیه',value:2},{label:'نمایش کل صورت وضعیت حمل بار با احتساب سود',value:3}]"
                                            item-value="value"
                                            item-text="label"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_select('3end_date_id_date_day')"
                                                    first_id="start_date_id_"
                                                    v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    first_id="3end_date_id_"
                                                    @last_focus="another_focus_inside('discharge_place3')"


                                                    v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>

                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="selected_discharge_place"
                                                    :cacheOptions="false"
                                                    id="discharge_place3"
                                                    :multiple="true"
                                                    :defaultExpandLevel="1"
                                                    :options="discharge_places_all"
                                                    placeholder="جستجو محل تخلیه"
                                                    :normalizer="normalizer_discharge_place"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_all" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-col cols="12">
                                <!--                                <v-row style="margin-right: 20px">-->
                                <!--                                    <div class="chip" v-for="item in selected_discharge_place" :key="item">-->
                                <!--                                        {{discharge_places.filter(x=>x.id==item)[0].name}}-->
                                <!--                                    </div>-->

                                <!--                                </v-row>-->

                                <VDataTable2
                                        dense
                                        hide-default-footer
                                        height="400"
                                        fixed-header
                                        disable-pagination
                                        v-if="items_delivery_all.length>0"
                                        multi-sort
                                        class="margin-auto  table-bordered"
                                        :headers="headers_deliver_profit"
                                        :items-per-page="1000"
                                        :items="items_delivery_all"
                                >
                                    <template v-slot:item.row_id="{item }">
                                        {{ item._row_index+1}}
                                    </template>
                                    <template v-slot:item.driver_price="{ item }">
                                        {{ get_currency(parseFloat(item.driver_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.total_real_driver_price="{ item }">
                                        {{ get_currency(parseFloat(item.total_real_driver_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.total_employer_price="{ item }">
                                        {{ get_currency(parseFloat(item.total_employer_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.employer_price="{ item }">
                                        {{ get_currency(parseFloat(item.employer_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.profit="{ item }">
                                        {{ get_currency( parseFloat(item.profit).toFixed(0))}}
                                    </template>
                                    <template v-slot:item.total="{ item }">
                                        {{ get_currency( parseFloat(item.total).toFixed(0))}}
                                    </template>
                                    <template slot="body.append">
                                        <tr class="pink--text">
                                            <th colspan="4" class="title">جمع کل</th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'count_truck')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_real_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_employer_price')) }}
                                            </th>
                                            <th class="title">
                                            </th>
                                            <th class="title">
                                            </th>
                                            <th class="title">{{ get_currency(parseFloat(calculate_items(items_delivery_all,
                                                'profit')).toFixed(0)) }}
                                            </th>
                                            <th class="title">{{ get_currency(parseFloat(calculate_items(items_delivery_all,
                                                'total')).toFixed(0)) }}
                                            </th>
                                        </tr>
                                    </template>
                                </VDataTable2>
                            </v-col>
                            <v-col v-show="false" cols="12" :id="body_id_profit">
                                <!--                                <v-row style="margin-right: 20px">-->
                                <!--                                    <div class="chip" v-for="item in selected_discharge_place" :key="item">-->
                                <!--                                        {{discharge_places.filter(x=>x.id==item)[0].name}}-->
                                <!--                                    </div>-->

                                <!--                                </v-row>-->

                                <VDataTable2
                                        dense
                                        hide-default-footer
                                        disable-pagination
                                        height="400"
                                        fixed-header
                                        v-if="items_delivery_all.length>0"
                                        multi-sort
                                        class="margin-auto  table-bordered"
                                        :headers="headers_deliver_profit_print"
                                        :items-per-page="1000"
                                        :items="items_delivery_all"
                                >
                                    <template v-slot:item.row_id="{item }">
                                        {{ item._row_index+1}}
                                    </template>

                                    <template v-slot:item.driver_price="{ item }">
                                        {{ get_currency(parseFloat(item.driver_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.total_real_driver_price="{ item }">
                                        {{ get_currency(parseFloat(item.total_real_driver_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.total_employer_price="{ item }">
                                        {{ get_currency(parseFloat(item.total_employer_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.employer_price="{ item }">
                                        {{ get_currency(parseFloat(item.employer_price).toFixed(0)) }}
                                    </template>
                                    <template v-slot:item.profit="{ item }">
                                        {{ get_currency( parseFloat(item.profit).toFixed(0))}}
                                    </template>
                                    <template v-slot:item.total="{ item }">
                                        {{ get_currency( parseFloat(item.total).toFixed(0))}}
                                    </template>
                                    <template slot="body.append">
                                        <tr class="pink--text">
                                            <th colspan="1" class="title">جمع کل</th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'count_truck')) }}
                                            </th>
                                            <th class="title" colspan="2"></th>

                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_real_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all,
                                                'total_employer_price')) }}
                                            </th>
                                            <th class="title">
                                            </th>
                                            <th class="title">
                                            </th>
                                            <th class="title">{{ get_currency(parseFloat(calculate_items(items_delivery_all,
                                                'profit')).toFixed(0)) }}
                                            </th>
                                            <th class="title">{{ get_currency(parseFloat(calculate_items(items_delivery_all,
                                                'total')).toFixed(0)) }}
                                            </th>
                                        </tr>
                                    </template>
                                </VDataTable2>
                            </v-col>
                            <v-btn small color="primary"
                                   @click="print_preview_with_header_title_height(body_id_profit,header_id_profit,footer_id,'Deliver Reports')">
                                پرینت
                            </v-btn>
                            <v-btn small color="success">
                                <download-excel
                                        class="btn btn-default"
                                        :data="table_excel_with_sum(items_delivery_all,[
                                      'count_truck',
'total_tonaje',
'total_real_tonaje',
'total_employer_price',
'profit',
'total'])"
                                        :fields="table_header_to_excel_heaader(headers_deliver_profit_print)"
                                        worksheet="My Worksheet"
                                        name="filename.xls"
                                >
                                    خروجی اکسل
                                </download-excel>
                            </v-btn>

                        </div>
                    </v-card-text>
                    <v-card-text v-if="report_type==4">
                        <div class="container">
                            <v-row>
                                <v-col cols="12" class="text-right">
                                    <h3> گزارشات</h3>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <v-select
                                            dense
                                            id="truck_type"
                                            v-model="report_type"
                                            :items="[{label:'نمایش کل صورت وضعیت حمل بار',value:1},{label:'نمایش روزانه کل صورت وضعیت حمل بار',value:4},{label:'ریز کارکرد محل تخلیه',value:2},{label:'نمایش کل صورت وضعیت حمل بار با احتساب سود',value:3}]"
                                            item-value="value"
                                            item-text="label"
                                    />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            از تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    @last_focus="another_focus_select('end_date_id_date_day')"
                                                    first_id="start_date_id_"
                                                    v-model="start_date"/>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="4">
                                    <v-row form class="form-group">
                                        <label class="col-form-label">
                                            تا تاریخ
                                        </label>
                                        <div>
                                            <ThreeDatePicker
                                                    first_id="end_date_id_"
                                                    @last_focus="another_focus_inside('discharge_place_3')"


                                                    v-model="end_date"/>
                                        </div>
                                    </v-row>
                                </v-col>

                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <div dir="rtl">
                                            <treeselect
                                                    v-model="one_discharge_places"
                                                    :multiple="true"
                                                    id="discharge_place_3"
                                                    :options="discharge_places_all"
                                                    placeholder="جستجو محل تخلیه"
                                                    :normalizer="normalizer_discharge_place"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-btn @click="get_data_all_daily" small color="primary">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-col cols="12" :id="body_id_daily">
                                <!--                                <v-row style="margin-right: 20px">-->
                                <!--                                    <div class="chip" v-for="item in selected_discharge_place" :key="item">-->
                                <!--                                        {{discharge_places.filter(x=>x.id==item)[0].name}}-->
                                <!--                                    </div>-->

                                <!--                                </v-row>-->

                                <VDataTable2
                                        dense
                                        hide-default-footer
                                        height="400"
                                        fixed-header
                                        disable-pagination
                                        v-if="items_delivery_all_daily.length>0"
                                        multi-sort
                                        class="margin-auto  table-bordered"
                                        :headers="headers_deliver_all_daily"
                                        :items-per-page="1000"
                                        :items="items_delivery_all_daily"
                                >
                                    <template v-slot:item.row_id="{item }">
                                        {{ item._row_index+1}}
                                    </template>

                                    <template v-slot:item.driver_price="{ item }">
                                        {{ get_currency(item.driver_price) }}
                                    </template>
                                    <template v-slot:item.total_real_driver_price="{ item }">
                                        {{ get_currency(item.total_real_driver_price) }}
                                    </template>
                                    <template v-slot:item.total_real_employer_price="{ item }">
                                        {{ get_currency(item.total_real_employer_price) }}
                                    </template>
                                    <template v-slot:item.profit="{ item }">
                                        {{ get_currency( item.total_real_employer_price - item.total_real_driver_price)
                                        }}
                                    </template>
                                    <template slot="body.append">
                                        <tr class="pink--text">
                                            <th colspan="4" class="title">جمع کل</th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all_daily,
                                                'count_truck')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all_daily,
                                                'total_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all_daily,
                                                'total_real_tonaje')) }}
                                            </th>
                                            <th class="title">{{ get_currency(calculate_items(items_delivery_all_daily,
                                                'total_real_employer_price')) }}
                                            </th>

                                        </tr>
                                    </template>
                                </VDataTable2>
                            </v-col>
                            <v-btn small color="primary"
                                   @click="print_preview_with_header_title_height(body_id_daily,header_id_daily,footer_id_daily,'Deliver Reports')">
                                پرینت
                            </v-btn>
                            <v-btn small color="success">
                                <download-excel
                                        class="btn btn-default"
                                        :data="table_excel_with_sum(items_delivery_all_daily,[
                                            'count_truck',
'total_tonaje',
'total_real_tonaje',
'total_real_employer_price'
                                        ])"
                                        :fields="table_header_to_excel_heaader(headers_deliver_all_daily)"
                                        worksheet="My Worksheet"
                                        name="filename.xls"
                                >
                                    خروجی اکسل
                                </download-excel>
                            </v-btn>
                        </div>
                    </v-card-text>


                </v-card>
            </v-col>
        </v-row>
        <div v-show="false" :id="header_id" style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
            <div>
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>خلاصه مالی صورت وضعیت حمل بار</strong>
                </v-row>
                <v-row>

                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </div>

        </div>
        <div v-show="false" :id="header_id_daily" style="margin-right: 50px;margin-left: 50px;margin-bottom: 70px">
            <div>
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>خلاصه روزانه مالی صورت وضعیت حمل بار</strong>
                </v-row>
                <v-row>

                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </div>

        </div>
        <div v-show="false" :id="header_id_profit" >
            <div style="margin-right: 50px;margin-left: 50px;">
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>خلاصه مالی صورت وضعیت حمل بار با احتساب سود</strong>
                </v-row>
                <v-row>

                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </div>

        </div>
        <div v-show="false" :id="header_id_one" >

            <div style="margin-right: 50px;margin-left: 50px;">
                <v-row style="justify-content:center">
                    <strong style="font-size: large">{{get_company_name()}}</strong>
                </v-row>

                <v-row style="justify-content:center">
                    <strong>صورت جلسه حمل بار</strong>
                </v-row>
                <v-row v-if="one_discharge_place!=null">

                    <v-col cols="9" style="text-align: right">
                        <p>مبدا بارگیری: {{discharge_places.filter(x=>x.id==one_discharge_place)[0].origin_load.name}}</p>
                        <p>محل تخلیه: {{discharge_places.filter(x=>x.id==one_discharge_place)[0].name}}</p>


                    </v-col>
                    <v-col cols="3">
                        <p>از تاریخ {{start_date}}</p>
                        <p>تا تاریخ {{end_date}}</p>

                    </v-col>

                </v-row>

            </div>

        </div>

        <div v-show="false" :id="footer_id" class="border-dark">
            <v-row style="border: 1px solid #000">
                <v-col cols="12" style="text-align: start">
                    <label>{{get_company_address()}}</label>
                </v-col>
            </v-row>
        </div>
        <div v-show="false" :id="footer_id_daily" class="border-dark">
            <v-row style="border: 1px solid #000">
                <v-col cols="12" style="text-align: start">
                    <label>{{get_company_address()}}</label>
                </v-col>
            </v-row>
        </div>
        <div v-show="false" :id="footer_bedon_sorat_id" class="border-dark">
            <div style="height: 200px">

            </div>
            <div style="position:fixed;bottom: 10px;width: 100%;">
            <v-row >

                    <v-col style="text-align: right" v-for="sign in signatures.filter(x=>x.status==1)" :key="sign.id">
                        <p style="text-align: center">{{sign.title}}</p>
                        <p style="text-align: center"> {{sign.name}}</p>
                    </v-col>
                </v-row>
                <v-row style="border: 1px solid #000">
                    <v-col cols="12" style="text-align: start">
                        <label>{{get_company_address()}}</label>
                    </v-col>
                </v-row>
            </div>
        </div>
        <div v-show="false" :id="footer_sorat_id" class="border-dark">
            <div style="height: 200px">

            </div>
            <div style="position:fixed;bottom: 10px;width: 100%;">
                <v-row style="text-align:right">
                    <v-col cols="6">
                        <v-row>
                            مهر و امضا
                        </v-row>
                    </v-col>
                    <v-col cols="6">
                        <v-row>
                            <v-col cols="12">جمع تناژ حمل شده:
                                {{get_currency(calculate_items(items_delivery_one, 'tonaje'))}}
                            </v-col>
                            <v-col cols="12">جمع تناژ مورد محاسبه:
                                {{get_currency(calculate_items(items_delivery_one, 'real_tonaje'))}}
                            </v-col>
                            <v-col cols="12">جمع مبلغ کل کارفرما:
                                {{get_currency(calculate_items(items_delivery_one,
                                'real_employer_price'))}}
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row style="border: 1px solid #000">
                    <v-col cols="12" style="text-align: start">
                        <label>{{get_company_address()}}</label>
                    </v-col>
                </v-row>
            </div>

        </div>

    </div>
</template>
<script>
    import Vue from 'vue'
    import {bus} from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ThreeDatePicker from "../includes/ThreeDatePicker";

    export default {
        name: 'OriginDownload',
        components: {
            Treeselect,
            ThreeDatePicker
        },
        data() {
            return {
                header_id: "print_header_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                header_id_daily: "print_header_ReportDeliveryLoadDetailDaily" + new Date().getTime() + this.$vnode.tag,
                header_id_profit: "print_header_profit_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                header_id_one: "print_header_one_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                body_id_one_non_profit: "print_header_one_non_profit_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                footer_id: "print_footer_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                footer_id_daily: "print_footer_ReportDeliveryLoadDetailDaily" + new Date().getTime() + this.$vnode.tag,
                footer_sorat_id: "print_footer_sorat_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                footer_bedon_sorat_id: "print_footer_bedon_sorat_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                body_id: "print_body_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                body_id_daily: "print_body_ReportDeliveryLoadDetailDaily" + new Date().getTime() + this.$vnode.tag,
                body_id_one: "print_body_one_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                body_id_profit: "print_body_profit_ReportDeliveryLoadDetail" + new Date().getTime() + this.$vnode.tag,
                non_profit_sortBy:[],
                non_profit_sortDesc:false,
                report_type: 1,
                tab: null,
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items_delivery_one: [],
                items_delivery_all: [],
                items_delivery_all_daily:[],
                status_form: 0,
                discharge_places: [],
                discharge_places_all: [],
                signatures: [],

                selected_discharge_place: [],
                one_discharge_place: null,
                one_discharge_places: [],
                start_date: null,
                end_date: null,
                headers_deliver_all: [
                    {
                        text: 'ردیف',
                        value: 'row_id',
                        width: '5%'
                    },
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'کد محل تخلیه',
                        value: 'discharge_place_code',
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place',
                        width: '20%'
                    },
                    {
                        text: 'تعداد سرویس',
                        value: 'count_truck'
                    },


                    {
                        text: 'تناژ واقعی',
                        value: 'total_tonaje'
                    },
                    {
                        text: 'تناژ مورد محاسبه',
                        value: 'total_real_tonaje'
                    },
                    {
                        text: 'جمع کل کارفرما',
                        value: 'total_real_employer_price'
                    },
                    // {
                    //     text: 'جمع کل کامیوندار',
                    //     value: 'total_real_driver_price'
                    // },
                    // {
                    //     text: 'سود',
                    //     value: 'profit'
                    // },


                ],
                headers_deliver_all_daily: [
                    {
                        text: 'ردیف',
                        value: 'row_id',
                        width: '5%'
                    },
                    {
                        text: 'تاریخ',
                        value: 'doc_date_persian'
                    },
                    {
                        text: 'کد محل تخلیه',
                        value: 'discharge_place_code',
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place',
                        width: '20%'
                    },
                    {
                        text: 'تعداد سرویس',
                        value: 'count_truck'
                    },


                    {
                        text: 'تناژ واقعی',
                        value: 'total_tonaje'
                    },
                    {
                        text: 'تناژ مورد محاسبه',
                        value: 'total_real_tonaje'
                    },
                    {
                        text: 'جمع کل کارفرما',
                        value: 'total_real_employer_price'
                    },
                    // {
                    //     text: 'جمع کل کامیوندار',
                    //     value: 'total_real_driver_price'
                    // },
                    // {
                    //     text: 'سود',
                    //     value: 'profit'
                    // },


                ],
                headers_deliver_profit: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'کد محل تخلیه',
                        value: 'discharge_place_code',
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place',
                        width:'20%'
                    },
                    {
                        text: 'تعداد سرویس',
                        value: 'count_truck'
                    },


                    {
                        text: 'تناژ واقعی',
                        value: 'total_tonaje'
                    },
                    {
                        text: 'تناژ مورد محاسبه',
                        value: 'total_real_tonaje'
                    },
                    {
                        text: 'مبلغ کل کارفرما',
                        value: 'total_employer_price'
                    },
                    {
                        text: 'نرخ کارفرما',
                        value: 'employer_price'
                    },
                    {
                        text: 'نرخ کامیوندار',
                        value: 'driver_price'
                    }, {
                        text: 'سود',
                        value: 'profit'
                    }, {
                        text: 'جمع کل',
                        value: 'total'
                    },


                ],
                headers_deliver_profit_print: [
                    {
                        text: 'ردیف',
                        value: 'row_id',
                        width: '5%'
                    },
                    {
                        text: 'تعداد سرویس',
                        value: 'count_truck'
                    },
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load',
                        width: '20%'
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place',
                        width: '20%'
                    },
                    {
                        text: 'کد محل تخلیه',
                        value: 'discharge_place_code',
                    },

                    {
                        text: 'تناژ واقعی',
                        value: 'total_tonaje',
                        width: '5%'
                    },
                    {
                        text: 'تناژ مورد محاسبه',
                        value: 'total_real_tonaje',
                        width: '5%'
                    },
                    {
                        text: 'مبلغ کل کارفرما',
                        value: 'total_employer_price'
                    },
                    {
                        text: 'نرخ حمل کارفرما',
                        value: 'employer_price'
                    },
                    {
                        text: 'نرخ حمل کامیوندار',
                        value: 'driver_price'
                    }, {
                        text: 'سود',
                        value: 'profit'
                    }, {
                        text: 'جمع کل',
                        value: 'total'
                    },


                ],
                headers_deliver_one: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'تاریخ',
                        value: 'doc_date_persian'
                    },
                    {
                        text: 'ش. بارنامه',
                        value: 'barname'
                    },
                    {
                        text: 'نوع بار',
                        value: 'load_type'
                    },
                    {
                        text: 'شماره پلاک',
                        value: 'truck_plate'
                    },
                    // {
                    //     text: 'نام کامیون',
                    //     value: 'truck_name'
                    // },
                    //
                    {
                        text: 'محور',
                        value: 'truck_type'
                    },
                    {
                        text: 'تناژ حمل شده',
                        value: 'tonaje'
                    },
                    {
                        text: 'تناژ مورد محاسبه',
                        value: 'real_tonaje'
                    },
                    // {
                    //     text: 'جنس بار',
                    //     value: 'load_type'
                    // },
                    //

                    {
                        text: 'نرخ حمل',
                        value: 'driver_price'
                    },
                    {
                        text: 'نرخ کارفرما',
                        value: 'employer_price'
                    },
                    {
                        text: 'مبلغ کارفرما',
                        value: 'total_real_employer_price'
                    },
                    // {
                    //     text: 'مبلغ راننده',
                    //     value: 'real_driver_price'
                    // },


                ],
                headers_deliver_one_non_profit: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'تاریخ',
                        value: 'doc_date_persian'
                    },
                    {
                        text: 'ش. بارنامه',
                        value: 'barname'
                    },
                  {
                    text: 'جنس بار',
                    value: 'load_type'
                  },
                    {
                        text: 'شماره پلاک',
                        value: 'truck_plate'
                    },
                    // {
                    //     text: 'نام کامیون',
                    //     value: 'truck_name'
                    // },
                    //
                    {
                        text: 'محور',
                        value: 'truck_type'
                    },
                    {
                        text: 'تناژ حمل شده',
                        value: 'tonaje'
                    },
                    {
                        text: 'تناژ مورد محاسبه',
                        value: 'real_tonaje'
                    },

                    //

                    // {
                    //     text: 'نرخ حمل',
                    //     value: 'driver_price'
                    // },
                    {
                        text: 'مبلغ کارفرما',
                        value: 'total_real_employer_price'
                    },
                    // {
                    //     text: 'مبلغ راننده',
                    //     value: 'real_driver_price'
                    // },


                ],

                normalizer_origin(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code:node.code,

                    }
                },
                normalizer_load_type(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code:node.code,

                    }
                },
                normalizer_discharge_place(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
            }
        },
        mounted() {
            // this.get_data()

            this.get_discharge_places()
            this.get_signatures()
            this.start_date = this.miladi_to_jalali(this.get_today())
            this.end_date = this.miladi_to_jalali(this.get_today())

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        watch: {
            // start_date: function () {
            //   this.get_data()
            // },
            // end_date: function () {
            //   this.get_data()
            // },
            //
            // selected_discharge_place: function () {
            //   this.get_data()
            // },

        },
        methods: {

            limited_tonaje(item) {

                var price = item.driver_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return tonaje;
            },
            real_paying_driver(item) {

                var price = item.driver_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)
            },
            deliver_employer(item) {

                var price = item.employer_price
                var tonaje = parseFloat(item.tonaje)
                if (item.tonaje_limit == 1) {
                    if (item.truck_type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (item.truck_type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(price) * tonaje)

            },

            get_data_all() {
                if (this.selected_discharge_place == []) {
                    return
                }
                localStorage.setItem("delivery_detail_discharges", JSON.stringify(this.selected_discharge_place))

                this.get_delivery_all()

            },
            get_data_all_daily() {
                if (this.selected_discharge_place == []) {
                    return
                }
                localStorage.setItem("delivery_detail_discharges", JSON.stringify(this.selected_discharge_place))

                this.get_delivery_all_daily()

            },
            get_data_one() {
                if (this.selected_discharge_place == []) {
                    return
                }

                this.get_delivery_one()

            },
            get_delivery_all() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))
                if (this.selected_discharge_place.filter(x => x == 0).length > 0) {
                    console.log("trucks", this.selected_discharge_place)

                    var final_discharge = [];
                    this.discharge_places.forEach(function (val) {
                        final_discharge.push(val.id);
                    })
                    formData.append('discharge_id', final_discharge)

                } else {
                    formData.append('discharge_id', this.selected_discharge_place)
                }
                this.axios.post('/api/delivery_document/select_by_multiple_discharge', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.items_delivery_all = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        self.items_delivery_all.forEach(function (val) {
                            // item.total_real_employer_price - item.total_real_driver_price
                            val.profit = parseInt(val.employer_price) - parseInt(val.driver_price)
                            val.total = parseInt(val.profit) * parseFloat(val.total_tonaje)
                            // val.calculated_driver_price = self.real_paying_driver(val)
                            // val.calculated_employer_price = self.deliver_employer(val)
                            val.tonaje = parseFloat(val.tonaje).toFixed(3)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_delivery_all_daily() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))
                    formData.append('discharge_id', JSON.stringify(this.one_discharge_places))
                this.axios.post('/api/delivery_document/select_by_multiple_discharge_daily', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.items_delivery_all_daily = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        self.items_delivery_all_daily.forEach(function (val) {
                            // item.total_real_employer_price - item.total_real_driver_price
                            val.profit = parseInt(val.employer_price) - parseInt(val.driver_price)
                            val.total = parseInt(val.profit) * parseFloat(val.total_tonaje)
                            // val.calculated_driver_price = self.real_paying_driver(val)
                            // val.calculated_employer_price = self.deliver_employer(val)
                            val.tonaje = parseFloat(val.tonaje).toFixed(3)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')
                    console.log(error)
                })

            },
            get_signatures() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/signatures/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.signatures = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            get_delivery_one() {
                var self = this
                const formData = new FormData()
                formData.append('start_date', this.jalali_to_miladi(this.start_date))
                formData.append('end_date', this.jalali_to_miladi(this.end_date))

                formData.append('discharge_id', this.selected_discharge_place)
                this.axios.post('/api/delivery_document/select_by_discharges', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.items_delivery_one = response.data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })

                        self.items_delivery_one.forEach(function (val) {

                            val.total_employer_price = parseFloat(val.tonaje) * parseFloat(val.employer_price)
                            val.total_real_employer_price = parseFloat(val.real_tonaje) * parseFloat(val.employer_price)
                            val.calculated_driver_price = self.real_paying_driver(val)
                            val.calculated_employer_price = self.deliver_employer(val)
                            val.tonaje = parseFloat(val.tonaje).toFixed(3)
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            get_discharge_places() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.discharge_places_all = [{id: 0, name: "همه موارد", code: "",children:[]}]
                        self.discharge_places = []
                        response.data.data.forEach(function (val) {
                            self.discharge_places.push(val)
                            self.discharge_places_all[0].children.push(val)
                        })
                        // self.discharge_places = response.data.data
                        self.selected_discharge_place = JSON.parse(localStorage.getItem("delivery_detail_discharges"))

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                    // if (self.$route.params.doc_id != null) {
                    //   self.status_form = self.$route.params.doc_id
                    //   self.get_data_all()
                    // }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            edit_item(item) {
                this.$router.push({path: '/edit-delivery-document/' + item.id})
            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id
            },
            delete_item() {
                const self = this
                const formData = new FormData()
                const url = '/api/delivery_document/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res)
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        }
    }
</script>
